import React from 'react';
import { ModalHeader } from '../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { Modal } from '../../../CommonComponents/OPL/Modal/Modal';
import { useClientListQuery } from '../../api/useClientListQuery';
import { AsyncStateItem } from './ClientList.styles';
import { Loading } from '../../../CommonComponents/OPL/Loading/Loading';
import { EmptyState } from '../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';
import { ClientListCombobox } from './components/ClientListCombobox/ClientListCombobox';
import { ErrorState } from '../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';

interface Props {
  onClose(): void;
}

export const ClientList: React.FC<Props> = ({ onClose }) => {
  return (
    <Modal variant="drawer" isOpen onRequestClose={onClose}>
      <ModalHeader hasBorder>Client list</ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ClientListContent />
    </Modal>
  );
};

export const ClientListContent = () => {
  const { isLoading, isFetching, isError, refetch, data } = useClientListQuery();

  if (isLoading) {
    return (
      <AsyncStateItem as="div">
        <Loading text="Loading..." />
      </AsyncStateItem>
    );
  }

  if (isError && !isFetching) {
    return (
      <AsyncStateItem as="div">
        <ErrorState onAction={refetch} />
      </AsyncStateItem>
    );
  }

  if (!data) {
    return null;
  }

  if (data.pages[0].clients.length === 0) {
    return (
      <AsyncStateItem as="div">
        <EmptyState message="No clients to display" />
      </AsyncStateItem>
    );
  }

  return <ClientListCombobox />;
};
